import { Component } from "react";
import { Row, Col, Button, Input, Label, Modal, ModalBody } from 'reactstrap';

class IfscMasterListFilterFrom extends Component {
    state = {
        corporateId: '',
        ifscCode: '',
        state: '',
        branchGst: '',
        salesAssociate: '',
        regionalManager: '',
        bankName: '',
        region: '',
        branchName: '',

    };

    componentDidUpdate(prevProps) {
        if (this.props.isOpen && !prevProps.isOpen && this.props.currentFilters) {
            this.setState({
                corporateId: this.props.currentFilters.corporateId || '',
                ifscCode: this.props.currentFilters.ifscCode || '',
                state: this.props.currentFilters.state || '',
                branchGst: this.props.currentFilters.branchGst || '',
                salesAssociate: this.props.currentFilters.salesAssociate || '',
                regionalManager: this.props.currentFilters.regionalManager || '',
                bankName: this.props.currentFilters.bankName || '',
                region: this.props.currentFilters.region || '',
                branchName: this.props.currentFilters.branchName || ''
            });
        }
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleApply = () => {
        this.props.onApply({
            corporateId: this.state.corporateId || null,
            ifscCode: this.state.ifscCode || null,
            state: this.state.state || null,
            branchGst: this.state.branchGst || null,
            salesAssociate: this.state.salesAssociate || null,
            regionalManager: this.state.regionalManager || null,
            bankName: this.state.bankName || null,
            region: this.state.region || null,
            branchName: this.state.branchName || null
        })
    }

    handleReset = () => {
        this.setState({
            corporateId: '',
            ifscCode: '',
            state: '',
            branchGst: '',
            salesAssociate: '',
            regionalManager: '',
            bankName: '',
            region: '',
            branchName: '',

        }, () => {
            this.props.onApply({
                corporateId: null,
                ifscCode: null,
                state: null,
                branchGst: null,
                salesAssociate: null,
                regionalManager: null,
                bankName: null,
                region: null,
                branchName: null,

            });
        });
    };

    renderField = (label, name, value, placeholder) => (
        <div>
            <Label className="mb-1 font-weight-500">{label}</Label>
            <Input
                type="text"
                name={name}
                value={value}
                onChange={this.handleChange}
                placeholder={placeholder}
                className="w-100"
                style={{ height: '38px' }}
            />
        </div>
    );

    render() {
        const { isOpen, toggle } = this.props;
        const { corporateId, ifscCode, state, branchGst, salesAssociate, regionalManager, bankName, region, branchName } = this.state;

        return (
            <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
                <ModalBody>
                    <Row className="mb-4">
                        <Col sm="12">
                            <div className="d-flex align-items-center">
                                <Label className="mr-2 font-weight-100" style={{ minWidth: '100px' }}>
                                    CorporateId:
                                </Label>
                                <Input
                                    type="text"
                                    name="corporateId"
                                    value={this.state.corporateId}
                                    onChange={this.handleChange}
                                    placeholder="Enter CorporateId"
                                    style={{ flex: 1, height: '38px' }}
                                />
                            </div>
                        </Col>

                        <Col sm="12">
                            <div className="d-flex align-items-center">
                                <Label className="mr-1 font-weight-500" style={{ minWidth: '100px' }}>
                                    IFSC:
                                </Label>
                                <Input
                                    type="text"
                                    name="ifscCode"
                                    value={this.state.ifscCode}
                                    onChange={this.handleChange}
                                    placeholder="Enter IFSC Code"
                                    style={{ flex: 1, height: '38px' }}
                                />
                            </div>
                        </Col>

                        <Col sm="12">
                            <div className="d-flex align-items-center">
                                <Label className="mr-1 font-weight-500" style={{ minWidth: '100px' }}>
                                    State:
                                </Label>
                                <Input
                                    type="text"
                                    name="state"
                                    value={this.state.state}
                                    onChange={this.handleChange}
                                    placeholder="Enter State name"
                                    style={{ flex: 1, height: '38px' }}
                                />
                            </div>
                        </Col>

                        <Col sm="12">
                            <div className="d-flex align-items-center">
                                <Label className="mr-1 font-weight-500" style={{ minWidth: '100px' }}>
                                    GST:
                                </Label>
                                <Input
                                    type="text"
                                    name="branchGst"
                                    value={this.state.branchGst}
                                    onChange={this.handleChange}
                                    placeholder="Enter GST"
                                    style={{ flex: 1, height: '38px' }}
                                />
                            </div>
                        </Col>

                    </Row>

                    <Row className="mb-4">
                        <Col sm="12">
                            <div className="d-flex align-items-center">
                                <Label className="mr-2 font-weight-500" style={{ minWidth: '100px' }}>
                                    Sales Associate:
                                </Label>
                                <Input
                                    type="text"
                                    name="salesAssociate"
                                    value={this.state.salesAssociate}
                                    onChange={this.handleChange}
                                    placeholder="Enter Sales Associate"
                                    style={{ flex: 1, height: '38px' }}
                                />
                            </div>
                        </Col>

                        <Col sm="12">
                            <div className="d-flex align-items-center">
                                <Label className="mr-2 font-weight-500" style={{ minWidth: '100px' }}>
                                    Regional Manager:
                                </Label>
                                <Input
                                    type="text"
                                    name="regionalManager"
                                    value={this.state.regionalManager}
                                    onChange={this.handleChange}
                                    placeholder="Enter Regional Manager"
                                    style={{ flex: 1, height: '38px' }}
                                />
                            </div>
                        </Col>

                        <Col sm="12">
                            <div className="d-flex align-items-center">
                                <Label className="mr-2 font-weight-500" style={{ minWidth: '100px' }}>
                                    Bank Name:
                                </Label>
                                <Input
                                    type="text"
                                    name="bankName"
                                    value={this.state.bankName}
                                    onChange={this.handleChange}
                                    placeholder="Enter Bank Name"
                                    style={{ flex: 1, height: '38px' }}
                                />
                            </div>
                        </Col>

                        <Col sm="12">
                            <div className="d-flex align-items-center">
                                <Label className="mr-2 font-weight-500" style={{ minWidth: '120px' }}>
                                    Region:
                                </Label>
                                <Input
                                    type="select"
                                    name="region"
                                    value={this.state.region}
                                    onChange={this.handleChange}
                                    style={{ flex: 1, height: '30px' , marginTop: '12px' }}
                                >
                                    <option value="">Select Region</option>
                                    <option value="South">South</option>
                                    <option value="West">West</option>
                                    <option value="East">East</option>
                                    <option value="North">North</option>
                                    <option value="Central">Central</option>
                                    <option value="Management">Management</option>
                                    <option value="Central Accounts">Central Accounts</option>
                                </Input>


                            </div>
                        </Col>

                        <Col sm="12">
                            <div className="d-flex align-items-center">
                                <Label className="mr-2 font-weight-500" style={{ minWidth: '100px' }}>
                                    Branch Name:
                                </Label>
                                <Input
                                    type="text"
                                    name="branchName"
                                    value={this.state.branchName}
                                    onChange={this.handleChange}
                                    placeholder="Enter Branch Name"
                                    style={{ flex: 1, height: '38px' }}
                                />
                            </div>
                        </Col>

                    </Row>


                    <div className="d-flex justify-content-between">
                        <div className="d-flex">
                            <Button outline color="primary" onClick={toggle}>
                                Hide Filters
                            </Button>

                            <Button
                                outline
                                color="primary"
                                className="ml-2"
                                onClick={this.handleReset}
                            >
                                Reset Filters
                            </Button>
                        </div>

                        <Button color="primary" onClick={this.handleApply}>
                            Apply
                        </Button>
                    </div>

                </ModalBody>
            </Modal>
        );
    }

}

export default IfscMasterListFilterFrom;